// Rotating banner images at the top of WebView pages. Gradient fallback if images fail to load.

import { useState, useEffect } from "react";

const BANNER_IMAGES = [
  "/images/banner-1.png",
  "/images/banner-2.png",
  "/images/banner-3.png",
];

const PLACEHOLDER_GRADIENTS = [
  "from-emerald-600/20 to-teal-700/30",
  "from-sky-600/20 to-indigo-700/30",
  "from-amber-500/15 to-orange-600/25",
];

export default function PageBanner() {
  const [index, setIndex] = useState(0);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setIndex(Math.floor(Math.random() * BANNER_IMAGES.length));
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % BANNER_IMAGES.length);
      setImgError(false);
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const src = BANNER_IMAGES[index];

  return (
    <div className="relative overflow-hidden rounded-xl mb-6 h-[120px]">
      {!imgError ? (
        <img
          src={src}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          className={`absolute inset-0 bg-gradient-to-br ${PLACEHOLDER_GRADIENTS[index]}`}
        />
      )}
    </div>
  );
}
